/**
 * ConfirmEmailBanner.tsx  -  Shown to account owners who haven't confirmed
 * their email yet. Classes can be set up, but children can't be added until
 * the address is confirmed.
 */
import { useState } from "react";
import { MailCheck } from "lucide-react";
import { api } from "@/api/client";
import { useAuthStore } from "@/store/authStore";

export function ConfirmEmailBanner() {
  const user = useAuthStore((s) => s.user);
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || user.role !== "school_admin" || user.emailVerifiedAt !== null) return null;

  async function resend() {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      setSent(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-shrink-0 flex-wrap items-center justify-between gap-3 bg-brand-blue-soft px-6 py-2.5 text-sm text-info-ink">
      <span className="flex items-center gap-2">
        <MailCheck className="h-4 w-4 flex-shrink-0" />
        {sent
          ? `We sent a new link to ${user.email}. Check your inbox and spam folder.`
          : `Please confirm ${user.email} using the link we emailed you. You can set up classes now; adding children unlocks once it's confirmed.`}
      </span>
      {!sent && (
        <button onClick={resend} disabled={busy} className="rounded-full border border-current px-3 py-1 text-xs font-bold disabled:opacity-60">
          Resend email
        </button>
      )}
    </div>
  );
}
